<template>
  <div class="landing-page">
    <div class="landing-container">
      <div class="landing-background">
        <img class="desktop" src="@/assets/img/landing.png" alt="landing background" />
        <img class="mobile" src="@/assets/img/landing-mob.jpg" alt="landing background" />
        <p class="btnPointer" @click="enter">前往交流會</p>
      </div>
    </div>

    <div class="loading-container" v-show="!loaded">
      <picture class="loading-animation">
        <source srcset="@/assets/img/loading.webp" type="image/webp" />
        <img src="@/assets/img/btgb2021_loading_00.png" alt="loading bar" />
      </picture>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    loaded: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    enter() {
      this.$emit("enter");
    },
  },
};
</script>
<style lang="scss" scoped>
.landing-page {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 2000;
  background: black;

  .landing-container {
    position: relative;
    width: 100%;
    height: 100%;

    .landing-background {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      p.btnPointer {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 28%;
        min-width: 260px;
        max-width: 300px;

        /* Linear */
        background: linear-gradient(
          267.88deg,
          rgba(80, 72, 170, 0.9) -3.15%,
          rgba(133, 67, 160, 0.9) 33.58%,
          rgba(216, 79, 79, 0.9) 70.83%,
          rgba(255, 142, 142, 0.9) 95.32%
        );
        border-radius: 32px;
        color: white;
        text-align: center;
        font-style: normal;
        font-weight: bold;
        letter-spacing: 0.02em;
        color: white;
      }
    }
  }

  .loading-container {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 1);

    .loading-animation {
      position: absolute;
      width: 100%;
      height: 100%;

      img {
        position: absolute;
        height: auto;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  // ------- desktop -------
  @media screen and (min-width: 769px) {
    .desktop {
      display: block;
    }
    .mobile {
      display: none;
    }
    .loading-animation img {
      width: 30%;
      max-width: 250px;
    }
    p.btnPointer {
      height: 50px;
      line-height: 50px;
      font-size: 18px;
      bottom: 5%;
    }
  }

  // ------ mobile ------
  @media screen and (max-width: 768px) {
    .desktop {
      display: none;
    }
    .mobile {
      display: block;
    }
    .loading-animation img {
      width: 40%;
      min-width: 190px;
      max-width: 220px;
    }
    p.btnPointer {
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      bottom: 10%;
    }
  }
}
</style>